import {
  FETCH_TRANSACTIONS_HISTORY_REQUEST,
  FETCH_TRANSACTIONS_HISTORY_SUCCESS,
  FETCH_TRANSACTIONS_HISTORY_FAILURE,
} from "./actionTypes";

const initialState = {
  transactions: [],
  loading: false,
  error: null,
};

const transactionHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSACTIONS_HISTORY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_TRANSACTIONS_HISTORY_SUCCESS:
      return { ...state, loading: false, transactions: action.payload };
    case FETCH_TRANSACTIONS_HISTORY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default transactionHistoryReducer;